"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageBlockRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
exports.ImageBlockRenderer = (0, react_1.memo)(({ block }) => {
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("img", { src: block.src, alt: "image in passage", style: {
            width: "auto",
            height: theme.spacing(30),
            alignSelf: "center",
            borderRadius: theme.spacing(1),
        } }));
});
exports.ImageBlockRenderer.displayName = "ImageBlockRenderer";
